import { Reader, Writer } from "protobufjs/minimal";
import type {
  ProfileAttribute,
  MissingAttributesHint,
} from "../../aysa_api/models/size_finder.types";

export const decodeProfileAttribute = (reader: Reader): ProfileAttribute => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    case 5:
      return 5;
    case 6:
      return 6;
    case 7:
      return 7;
    case 8:
      return 8;
    case 9:
      return 9;
    case 10:
      return 10;
    case 11:
      return 11;
    case 12:
      return 12;
    case 13:
      return 13;
    case 14:
      return 14;
    case 15:
      return 15;
    default:
      return 0;
  }
};

export const encodeProfileAttribute = (
  writer: Writer,
  value: ProfileAttribute
): Writer => {
  return writer.int32(value);
};

export const createBaseMissingAttributesHint = (): MissingAttributesHint => {
  return {
    missingRequiredAttributes: [],
    missingSuggestedAttributes: [],
  };
};

export const decodeMissingAttributesHint = (
  reader: Reader,
  length: number
): MissingAttributesHint => {
  const end = reader.pos + length;
  const message = createBaseMissingAttributesHint();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        const packedEnd1 = reader.uint32() + reader.pos;
        while (reader.pos < packedEnd1) {
          message.missingRequiredAttributes.push(
            decodeProfileAttribute(reader)
          );
        }

        break;
      case 2:
        const packedEnd2 = reader.uint32() + reader.pos;
        while (reader.pos < packedEnd2) {
          message.missingSuggestedAttributes.push(
            decodeProfileAttribute(reader)
          );
        }

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeMissingAttributesHint = (
  writer: Writer,
  message: MissingAttributesHint
): Writer => {
  writer.uint32(10).fork();
  for (const value of message.missingRequiredAttributes) {
    encodeProfileAttribute(writer, value);
  }
  writer.ldelim();
  writer.uint32(18).fork();
  for (const value of message.missingSuggestedAttributes) {
    encodeProfileAttribute(writer, value);
  }
  writer.ldelim();

  return writer;
};
